import React from "react";
export function AppShell({ logo, productName, children }:{ logo?:string; productName?:string; children: React.ReactNode }) {
  return (
    <div>
      <header className="sticky top-0 z-10 bg-white/70 backdrop-blur border-b">
        <nav className="mx-auto flex max-w-6xl items-center justify-between p-4">
          <div className="flex items-center gap-2">
            {logo ? <img src={logo} alt="logo" className="h-6" /> : null}
            <span className="font-semibold">{productName ?? "Van Moose"}</span>
          </div>
          <div className="flex items-center gap-3">
            <a href="/api/auth/signin" className="underline">Sign in</a>
            <a href="/api/auth/signin" className="rounded-xl border px-3 py-1">Get started</a>
          </div>
        </nav>
      </header>
      {children}
      <footer className="mx-auto max-w-6xl p-8 text-sm opacity-70">© {new Date().getFullYear()} Van Moose</footer>
    </div>
  );
}
export default AppShell;
